<svg xmlns="http://www.w3.org/2000/svg" width="11.384" height="5.293" viewBox="0 0 11.384 5.293">
  <g id="drop_down" data-name="drop down" transform="translate(-1879.795 -40.055)">
    <path id="Tracé_66" data-name="Tracé 66" d="M1887.487,45.348a1,1,0,0,1-.707-.293L1881.8,40.07c-.038-.042,11.363.018,11.384,0l-4.985,4.985A1,1,0,0,1,1887.487,45.348Z" transform="translate(-2)" fill="#3c3c3b"/>
  </g>
</svg>
